import { makeObservable, observable, action } from "mobx";

class AuthStore {
    isLoggedIn = false;

    constructor() {
        makeObservable(this, {
            isLoggedIn: observable,
            login: action,
            logout: action,
        });

        // 检查本地存储中是否存在登录状态
        const storedIsLoggedIn = localStorage.getItem('isLoggedIn');
        if (storedIsLoggedIn) {
            this.isLoggedIn = JSON.parse(storedIsLoggedIn);
        }
    }

    login() {
        // 在此处执行登录操作，例如验证用户凭据等
        // 登录成功后将isLoggedIn设置为true
        this.isLoggedIn = true;

        // 将登录状态保存到本地存储中
        localStorage.setItem('isLoggedIn', JSON.stringify(this.isLoggedIn));
    }

    logout() {
        // 在此处执行注销操作，例如清除用户凭据等
        // 注销成功后将 isLoggedIn 设置为 false
        this.isLoggedIn = false;
    
        // 清除本地存储中的登录状态
        localStorage.removeItem('isLoggedIn');
      }
}


const authStore = new AuthStore();
export default authStore;